import { render } from "./InterfaceTab.vue?vue&type=template&id=e777e1fa&scoped=true"
import script from "./InterfaceTab.vue?vue&type=script&lang=js"
export * from "./InterfaceTab.vue?vue&type=script&lang=js"

import "./InterfaceTab.vue?vue&type=style&index=0&id=e777e1fa&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e777e1fa"]])

export default __exports__